import { render, staticRenderFns } from "./MenuContentMobile.vue?vue&type=template&id=4c18f489&"
import script from "./MenuContentMobile.vue?vue&type=script&lang=js&"
export * from "./MenuContentMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports